/*
 * @Description: Description
 * @Author: 艾欢欢
 * @Date: 2020-12-21 15:39:11
 * @LastEditTime: 2021-05-12 15:47:43
 * @LastEditors: 艾欢欢<ahh666@qq.com>
 * @FilePath: \openplat-web\src\gtn\components\dialog\index.js
 */
import Vue from 'vue'
import Dialog from './LoginModal.vue'
import router from '@/router';
import store from '@/store';

const DialogCtor = Vue.extend(Dialog)
const InitDialog = opt => {
  const i = window.i
  if(i && i.$el && document.body.contains(i.$el)){
    document.body.removeChild(window.i.$el)
    // return
  }
  window.i = new DialogCtor({
    data: opt,
    router,
    store,
  }).$mount()
  document.body.appendChild(window.i.$el)
}

const modal = opt => {
  return InitDialog({
    ...opt,
    autoClose: false
  })
}

const install = () => {
  Vue.prototype.$dialog = { modal }
}

export default install



// WEBPACK FOOTER //
// ./src/gtn/components/dialog/index.js